module.exports = __webpack_public_path__ + "img/xlogo_jlab.8f69f9a0.jpg";